import Slider from "react-slick";
import acb from "../../assets/svgs/soundbox/acb.svg";
import bidv from "../../assets/svgs/soundbox/bidv.svg";
import mb from "../../assets/svgs/soundbox/mbbank.svg";
import ocbbank from "../../assets/svgs/soundbox/ocbbank.svg";
import viettink from "../../assets/svgs/soundbox/viettink.svg";
import vp from "../../assets/svgs/soundbox/vp.svg";

import { useWindowSize } from "@uidotdev/usehooks";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

export const SliderBank = () => {
  const { width } = useWindowSize();

  let number;
  if (width > 1326) {
    number = 5;
  } else if (width <= 1326 && width > 1070) {
    number = 4;
  } else if (width <= 1070 && width > 850) {
    number = 3;
  } else if (width <= 850 && width > 570) {
    number = 2;
  } else {
    number = 1;
  }

  const settings = {
    dots: true,
    arrows: false, // Ẩn các mũi tên điều hướng
    infinite: true,
    speed: 500,
    slidesToShow: number,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3800,

    marginLeft: "15px",
  };
  return (
    <div className="slider-container relative mt-[30px]">
      <Slider className="slider-2 sm:text-center " {...settings}>
        {/* <div className=" sliderItem h-[80px] w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={techcombank} />
        </div> */}
        <div className=" sliderItem w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={ocbbank} />
        </div>
        <div className=" sliderItem w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={acb} />
        </div>
        <div className=" sliderItem w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={bidv} />
        </div>
        <div className=" sliderItem w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={mb} />
        </div>
        <div className=" sliderItem mr-[30px] w-[156px]  rounded-[20px] bg-white">
          <img className="text-center" src={vp} />
        </div>
        {/* <div className=" sliderItem w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={vietcombank} />
        </div> */}

        {/* <div className=" sliderItem w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={exim} />
        </div> */}
        <div className=" sliderItem w-[156px] rounded-[20px]  bg-white">
          <img className="text-center" src={viettink} />
        </div>
        {/* <div className=" sliderItem mr-[30px] w-[156px]  rounded-[20px] bg-white">
          <img className="text-center" src={ms} />
        </div> */}

        {/* <div className=" sliderItem mr-[30px] w-[156px]  rounded-[20px] bg-white">
          <img className="text-center" src={vietinbank} />
        </div> */}
      </Slider>
    </div>
  );
};
